import type { RevenueSource } from "@/types/api";

const TONES: Record<RevenueSource, string> = {
  vast: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  contract: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  mixed: "bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300",
  idle: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  unknown: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
};

export function RevenueSourcePill({ source }: { source: RevenueSource }) {
  return (
    <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${TONES[source]}`}>
      {source}
    </span>
  );
}

export function ContractEndBadge({ end, today }: { end: string | null; today: Date }) {
  if (!end) return <span className="text-slate-400 text-xs">—</span>;
  const endDate = new Date(end + "T00:00:00");
  const days = Math.round((endDate.getTime() - today.getTime()) / (24 * 60 * 60 * 1000));
  let tone = "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300";
  if (days < 0) tone = "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300";
  else if (days <= 14) tone = "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300";
  else if (days <= 60) tone = "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300";
  return (
    <span className={`inline-block rounded-full px-2 py-0.5 text-xs ${tone}`} title={end}>
      {days < 0 ? `expired ${Math.abs(days)}d` : `${days}d`}
    </span>
  );
}
